module.exports = "<div class=\"gw-wizard-main\">\n\n    <div class=\"gw-page gw-box\">\n       <!-- <div class=\"gw-wizard-progress\" gw-wizard-step-progress></div> 17.02.2017 we don't want guide wire mobile navigation-->\n        <div ng-transclude></div>\n    </div>\n    <div class=\"gw-preventActionsLayer\" ng-class=\"{'gw-locked': sidebarMenuVisible()}\"\n         ng-click=\"hideSidebarMenu()\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/wizard/templates/wizard-content.html
// module id = 878
// module chunks = 0